import { Controller } from '@hotwired/stimulus';
import { getItem, setItem, removeItem } from '../helpers/local_storage';

const STORAGE_KEY = 'organisation_device_key';

export default class extends Controller {
  static values = {
    url: String,
    currentKey: String,
    returnTo: String,
    clear: Boolean,
  };

  connect() {
    if (this.clearValue || this.shouldClearStorage()) {
      removeItem(STORAGE_KEY);
      return;
    }

    if (this.currentKeyValue) {
      setItem(STORAGE_KEY, this.currentKeyValue);
      if (this.returnToValue) {
        window.location.replace(this.returnToValue);
      }
      return;
    }

    const storedKey = getItem(STORAGE_KEY);
    if (storedKey) {
      this.restoreDevice(storedKey);
    } else if (this.returnToValue) {
      window.location.replace(this.returnToValue);
    }
  }

  restoreDevice(deviceKey) {
    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]'
    )?.content;
    if (!csrfToken) return;

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = this.urlValue;
    form.style.display = 'none';

    const keyInput = document.createElement('input');
    keyInput.type = 'hidden';
    keyInput.name = 'device_key';
    keyInput.value = deviceKey;
    form.appendChild(keyInput);

    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'authenticity_token';
    tokenInput.value = csrfToken;
    form.appendChild(tokenInput);

    document.body.appendChild(form);
    form.submit();
  }

  shouldClearStorage() {
    const params = new URLSearchParams(window.location.search);
    return params.get('clear_device_storage') === '1';
  }
}
